export const AVATAR_REGION = "westus2";
export const AVATAR_SUB_KEY = "ff63b878e18c438bbfb3cc1e71d2db0e";
export const AVATAR_API_KEY = "397fe75442984df8a40d6277806ab976";
export const TRANSLATE_KEY = "6846aeb4d00343a19bd294179c661ea0";
export const TRANSLATE_LOCATION = "eastus2";
export const TRANSLATE_ENDPOINT="https://api.cognitive.microsofttranslator.com"
// export const AVATAROpenAIEndpoint="https://lipi-azureopenai.openai.azure.com/"
export const AVATAROpenAIEndpoint="https://jarvis-azureopenai.openai.azure.com/"
// export const BackendURL="https://devlipi-d0h0gmapdxhsh4fr.centralindia-01.azurewebsites.net"
// export const BackendURL="http://localhost:5000"
// export const BackendURL="https://lipi.motherson.com"
export const BackendURL="https://lipi-jarvis.prysm.mtsltechnology.com"
